import { AxiosResponse } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { $axios } from './axios'
import { InboxType } from '../../server/models/Inbox'

export const createInbox = (
  body: {
        name: string
    }
): Promise<AxiosResponse<InboxType>> => {
  return $axios.post('/inboxes', body)
}

export const getInboxes = (): Promise<AxiosResponse<InboxType[]>> => {
  return $axios.get('/inboxes')
}

export const getInbox = (inboxId: string): Promise<AxiosResponse<InboxType>> => {
  return $axios.get(`/inboxes/${inboxId}`)
}

export const updateInbox = (
  inboxId: string,
  body: {
    private: boolean
  }
): Promise<AxiosResponse<InboxType>> => {
  return $axios.put(`/inboxes/${inboxId}`, body)
}

export const deleteInbox = (inboxId: string): Promise<AxiosResponse<void>> => {
  return $axios.delete(`/inboxes/${inboxId}`)
}

export const getInboxPublications = (inboxId: string): Promise<AxiosResponse<string[]>> => {
  return $axios.get(`/inboxes/${inboxId}/publications`)
}

export const useInboxesQuery = (
  options?: Omit<UseQueryOptions<InboxType[], Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<InboxType[], Error>({
    queryKey: ['inboxes'],
    queryFn: async () => {
      const res = await getInboxes()
      return res.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - liberal caching
    gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for a long time
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options
  })
}

export const useInboxPublicationsQuery = (
  inboxId: string,
  options?: Omit<UseQueryOptions<string[], Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<string[], Error>({
    queryKey: ['inboxPublications', inboxId],
    queryFn: async () => {
      const res = await getInboxPublications(inboxId)
      return res.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - liberal caching
    gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for a long time
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options
  })
}
